export default "__VITE_ASSET__e35c46bd__"